import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const Kamion = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL('/carrier/tms/' + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = '/carrier/tms/';
    }
  }, [pathURL]);
  return <div />;
};

export default Kamion;
